<template>
    <div class="nav-container">
        <ul v-if="mode===1" class="ul1">
            <template v-for="(router, index) in routerList">
                <div v-if="canIUse(router.privilegeId)"
                    :key="router.id"
                    :class="{ 'has-classification has-classification-1': canShowClassification(router, 1) }">
                    <span class="classification" v-if="canShowClassification(router, 1)">{{ router.classification }}</span>
                    <router-link
                    tag="li"
                    :to="{path: router.linkHref}"
                    :ref="'index-' + index">
                        <div class="item item1"
                        @mouseover="navHover(index, router, $event)"
                        @mouseout="navBlur(index, router, $event)">
                            <div class="img-box">
                                <img v-if="router.linkHref === '/main/aiAssistant'" class="ai-nav-avatar" :src="aiAssistantNavIcon" alt="" referrerpolicy="no-referrer" />
                                <i v-else :class="urlRouter===router.linkHref?router.iconL:router.icon"></i>
                            </div>
                            <div class="name" style="font-size: 16px;">{{router.name}}</div>
                            <!-- <div class="dot" v-if="router.name=='采购订货'&& isShowRedDot"></div> -->
                        </div>
                        <!-- <span class="pop" v-if="router.name=='采购订货' && demandOrderUpDateStatus.total > 0">{{demandOrderUpDateStatus.total}}</span> -->
                    </router-link>
                </div>
            </template>
            <li style="background: #e7e7e7;"></li>
        </ul>
        <ul v-if="mode===2" class="ul2">
            <template v-for="(router, index) in routerList">
                <div v-if="canIUse(router.privilegeId)"
                    :key="router.id"
                    :class="{ 'has-classification has-classification-2': canShowClassification(router, 2) }">
                    <span class="classification" v-if="canShowClassification(router, 2)">{{ ' ' }}</span>
                    <router-link
                    tag="li"
                    :to="{path: router.linkHref}"
                    :ref="'index-' + index">
                        <div class="item item2"
                        @mouseover="navHover(index, router, $event)"
                        @mouseout="navBlur(index, router, $event)">
                            <div class="img-box">
                                <img v-if="router.linkHref === '/main/aiAssistant'" class="ai-nav-avatar" :src="aiAssistantNavIcon" alt="" referrerpolicy="no-referrer" />
                                <i v-else style="display: inline-block;" :class="urlRouter===router.linkHref?router.iconL:router.icon"></i>
                            </div>
                            <div class="navName name" style="font-size: 12px; line-height: 12px;">{{router.name}}</div>
                            <!-- <div class="nav-name">{{router.name}}</div> -->
                            <!-- <div class="dot" style="font-size: 12px; line-height: 12px;" v-if="router.name=='采购订货'&& isShowRedDot"></div> -->
                        </div>
                        <!-- <span class="pop" v-if="router.name=='采购订货' && demandOrderUpDateStatus.total > 0">{{demandOrderUpDateStatus.total}}</span> -->
                    </router-link>
                </div>
            </template>
            <li style="background: #e7e7e7;"></li>
        </ul>
        <div class="switch" :class="'switch-' + mode" @click="switchNav">
            <img v-show="mode===1" src="https://static.pf.senguo.cc/static/boss/img/nav_retraction.png?v=5df8631be4115645ecc382d3d9a006ce" alt="" >
            <img v-show="mode===2" src="https://static.pf.senguo.cc/static/boss/img/nav_spread.png?v=2dc969faf9922e9e3ed97f3343d035c3" alt="" >
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import { createComponent, reactive, ref, computed, SetupContext, onBeforeUpdate, onBeforeUnmount } from '@vue/composition-api'
import { VNode, VueConstructor } from 'vue'

interface RouterItem  {
    id: number
    linkHref: string
    name: string
    classification: string
    privilegeId?: number
    icon: string
    iconL: string
}

const aiAssistantNavIcon = 'https://img.senguo.cc/assets/pf/ai-assistant/avatar/20260710/v1/ai-avatar-person-nav-wave-loose.webp'

const Comp = createComponent({
    computed: {
        ...mapState('shop', ['staffInfo']),
        ...mapGetters('shop', ['canIUse']),
        canShowClassification() {
            const classificationListOne = [{
                id: 0,
                name: '数据',
                value: true
            }, {
                id: 0,
                name: '管理',
                value: true
            }, {
                id: 0,
                name: '功能',
                value: true
            }, {
                id: 0,
                name: '设置',
                value: true
            }]
            const classificationListTwo = [{
                id: 0,
                name: '数据',
                value: true
            }, {
                id: 0,
                name: '管理',
                value: true
            }, {
                id: 0,
                name: '功能',
                value: true
            }, {
                id: 0,
                name: '设置',
                value: true
            }]
            return (router: {
                id: number,
                linkHref: string,
                name: string,
                classification: string,
                privilegeId: number,
                icon: string,
                iconL: string
            },      mode = 1) => {
                if (router.privilegeId != null && router.privilegeId !== 0 && !(this.staffInfo as any).permission_list.includes(router.privilegeId)) {
                    return false
                }
                const classificationList = mode === 1 ? classificationListOne : classificationListTwo
                const classification = classificationList.find(c => c.name === router.classification) as {
                    id: number,
                    name: string,
                    value: boolean
                }
                if (classification.value || classification.id === router.id) {
                    classification.id = router.id
                    classification.value = false
                    return true
                }
                return classification.value
            }
        }
    },
    setup(props: any, ctx: SetupContext) {
        /**
         * [
         *  0  超管权限
         *  1  管理员权限
         *  2  收银员权限
         *  3  店铺数据权限
         *  4  会员管理权限
         *  5  店铺设置权限
         *  6  添加员工权限
         *  7  删除员工权限
         *  8  编辑管理员权限
         *  9  订单退款权限
         *  10 添加/删除商品权限
         *  11 上架或下架商品权限
         *  12 收银员改价
         *  13 收银员订单减免
         *  14 收银台退款
         * ]
         */
        const routerList = ref<RouterItem[]>([{
            id: 7,
            linkHref: '/main/aiAssistant',
            name: 'AI助手',
            classification: '数据',
            privilegeId: 0,
            icon: 'ai-nav-icon',
            iconL: 'ai-nav-icon ai-nav-icon-active'
        }, {
            id: 0,
            linkHref: '/main/dataCenter',
            name: '店铺数据',
            classification: '数据',
            privilegeId: 3,
            icon: 'iconfont iconshujuweixuanzhong',
            iconL: 'iconfont iconshuju-xuanzhong'
        }, {
            id: 1,
            linkHref: '/main/goodsLibrary',
            name: '商品',
            classification: '管理',
            privilegeId: 0,
            icon: 'iconfont iconhpk-h',
            iconL: 'iconfont iconhpk-l'
        }, {
            id: 2,
            linkHref: '/main/orderForm',
            name: '订单',
            classification: '管理',
            privilegeId: 0,
            icon: 'iconfont icondingdan-weixuan',
            iconL: 'iconfont icondingdan-yixuan'
        }, {
            id: 3,
            linkHref: '/main/member',
            name: '会员',
            classification: '管理',
            privilegeId: 4,
            icon: 'iconfont iconkehu-weixuan',
            iconL: 'iconfont iconkehu-yixuan'
        }, {
            id: 4,
            linkHref: '/main/staff',
            name: '员工',
            classification: '管理',
            privilegeId: 0,
            icon: 'iconfont iconyg-h1',
            iconL: 'iconfont iconyg-l1'
        }, {
            id: 5,
            linkHref: '/main/market',
            name: '营销玩法',
            classification: '功能',
            privilegeId: 0,
            icon: 'iconfont iconyingxiao-weixuanzhong',
            iconL: 'iconfont iconyingxiao-xuanzhong'
        }, {
            id: 6,
            linkHref: '/main/configuration',
            name: '设置',
            classification: '设置',
            privilegeId: 5,
            icon: 'iconfont iconshezhi',
            iconL: 'iconfont iconshezhixuanzhong'
        }])

        const mode = ref(1)

        const urlRouter = computed(() => {
            if (ctx.root.$route.matched.length >= 2) {
                return ctx.root.$route.matched[1].path
            } else {
                return ''
            }
        })

        function navHover(index: number, router: RouterItem, event: Event) {
            // console.log(arguments, ctx.refs)
            // let index = 0
            // if (event.currentTarget) {
            //     const dataset = (event.currentTarget as HTMLElement).dataset
            //     if (dataset) {
            //         index = dataset.index
            //     }
            // } else {
            //     return
            // }

            try {
                if (index !== 0) {
                    const targetIndex = index - 1
                    if (ctx.refs != null && ctx.refs['index-' + targetIndex] && (ctx.refs['index-' + targetIndex] as Vue[])[0].$el.classList.contains('router-active')) {
                        (ctx.refs['index-' + targetIndex] as Vue[])[0].$el.classList.add('activ1')
                    }
                }

                if (index !== routerList.value.length - 1) {
                    const targetIndex = index + 1
                    if (ctx.refs != null && ctx.refs['index-' + targetIndex] && (ctx.refs['index-' + targetIndex] as Vue[])[0].$el.classList.contains('router-active')) {
                        (ctx.refs['index-' + targetIndex] as Vue[])[0].$el.classList.add('active2')
                    }
                }

                if (ctx.refs != null && ctx.refs['index-' + index] && !(ctx.refs['index-' + index] as Vue[])[0].$el.classList.contains('router-active')) {
                    (event!.currentTarget as Document).getElementsByTagName('i')[0].className = router.iconL
                }
            } catch (e) {}
        }

        function navBlur(index: number, router: RouterItem, event: Event) {
            try {
                // const index = +event.currentTarget.dataset.index
                // event.currentTarget.getElementsByTagName('i')[0].className = router.icon
                routerList.value.forEach((value) => {
                    ctx.refs != null && ctx.refs['index-' + index] && (ctx.refs['index-' + index] as Vue[])[0].$el.classList.remove('active1')
                    ctx.refs != null && ctx.refs['index-' + index] && (ctx.refs['index-' + index] as Vue[])[0].$el.classList.remove('active2')
                })
                if (ctx.refs != null && ctx.refs['index-' + index] && !(ctx.refs['index-' + index] as Vue[])[0].$el.classList.contains('router-active')) {
                    (event.currentTarget as Document).getElementsByTagName('i')[0].className = router.icon
                }
            } catch (e) {}
        }

        function switchNav() {
            if (mode.value === 1) {
                mode.value = 2
            } else {
                mode.value = 1
            }
        }

        return {
            mode,
            routerList,
            urlRouter,
            aiAssistantNavIcon,
            // navItemDom,
            navHover,
            navBlur,
            switchNav
        }
    }
})

export default Comp
</script>

<style lang="scss" scoped>
.nav-container {
    padding: 0;
    width: 100%;
    position: relative;
    height: 100%;
    overflow: hidden;
    // height: 410px;

    .switch {
        position: fixed;
        bottom: 0;
        text-align: center;
        background-color: rgba(0, 0, 0, 0.3);
        height: 22px;
        line-height: 24px;
        ;
        cursor: pointer;

        &.switch-1 {
            width: 130px;
        }

        &.switch-2 {
            width: 62px;
        }

        &:hover {
            background-color: rgba(0, 0, 0, .5);
        }

        img {
            height: 14px;
        }
    }

    .ul1 {
        width: 130px;
    }

    .ul2 {
        width: 62px;
    }

    .name {
        color: #333;
    }

    .ai-nav-avatar {
        display: inline-block;
        width: 24px;
        height: 24px;
        margin-right: 5px;
        object-fit: contain;
    }

    ul {
        // width: 130px;
        background: #e7e7e7;
        overflow: hidden;
        ;

        li {
            height: 46px;
            line-height: 46px;
            text-align: center;
            display: flex;
            // padding-left: 20px;
            cursor: pointer;

            &:not(.router-active):hover {
                background: #ebebeb;
                // border-radius: 100px;
                position: relative;
            }

            &:not(.router-active):hover i {
                // border-radius: 100px;
                color: #666;
            }

            .item1 {
                position: relative;
                width: 130px;
                display: flex;
                align-items: center;
                padding-left: 20px;
                font-size: 16px;

                .dot {
                    position: absolute;
                    z-index: 21;
                    top: 10px;
                    right: 10px;
                    display: block;
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background: #ee5b5b;
                }
            }

            .item2 {
                position: relative;
                width: 62px;
                display: flex;
                flex-direction: column;
                // padding-left: 20px;

                .img-box {
                    display: block;
                    width: 22px;
                    height: 22px;
                    margin: 0 auto;
                    margin-bottom: 2px;
                }

                .navName {
                    display: none;
                }

                .dot {
                    position: absolute;
                    z-index: 21;
                    top: 10px;
                    right: 10px;
                    display: block;
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background: #ee5b5b;
                }
            }

            &:not(.router-active):hover .item {
                position: relative;
            }

            &:not(.router-active):hover .active1::after {
                background-color: #ebebeb !important;
            }

            &:not(.router-active):hover .item::before {
                content: '';
                display: block;
                width: 15px;
                height: 66px;
                background-color: #ebebeb;
                position: absolute;
                right: 0;
                top: -10px;
            }

            .pop {
                position: absolute;
                top: -5px;
                right: 0;
                padding: 3px;
                border-radius: 15px;
                background: #f66;
                color: #333;
                min-width: 20px;
                height: 20px;
                line-height: 14px;
                font-size: 12px;
            }

            .img-box {
                .iconfont {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 22px;
                    height: 46px;
                    font-size: 22px;
                    // vertical-align: middle;
                    margin-right: 5px;
                }
            }
        }

        .router-active {
            // padding-left: 16px;
            // display: block;
            background-color: #fff !important;
            opacity: 1;
            // border-left: 4px solid #009688;
            position: relative;
            color: #009688 !important;

            .item .name {
                color: #009688;
                font-weight: bold;
                z-index: 100;
            }

            > .item::after {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                width: 4px;
                background-color: #009688;
            }
        }

        @keyframes imgUp {
            0% { transform: translateY(0); }
            100% { transform: translateY(-8px); }
        }

        @keyframes textUp {
            0% { transform: translateY(0); }
            100% { transform: translateY(6px); }
        }

        .router-active .navName {
            display: block !important;
            transform: translateY(6px);
        }

        .router-active .item2 .img-box i {
            animation: imgUp 0.3s;
            animation-fill-mode: forwards;
        }

        .router-active .item::before {
            z-index: 21;
            content: '';
            display: block;
            width: 15px;
            height: 66px;
            position: absolute;
            right: 0;
            top: -10px;
            background-color: #fff;
        }

        li:not(.router-active) .item2:hover .navName {
            display: block;
            animation: textUp 0.3s;
            animation-fill-mode: forwards;
        }

        li:not(.router-active) .item2:hover .img-box i {
            animation: imgUp 0.3s;
            animation-fill-mode: forwards;
        }

        .router-active::before {
            z-index: 22;
            content: '';
            display: block;
            width: 15px;
            height: 15px;
            border-radius: 0 0 15px 0;
            background-color: #e7e7e7;
            position: absolute;
            right: 0;
            top: -15px;
        }

        .router-active::after {
            z-index: 22;
            content: '';
            display: block;
            width: 15px;
            height: 15px;
            border-radius: 0 15px 0 0;
            background-color: #e7e7e7;
            position: absolute;
            right: 0;
            bottom: -15px;
        }

        .active1::after {
            background-color: #ebebeb !important;
        }

        .active2::before {
            background-color: #ebebeb !important;
        }
    }
}

li:not(.router-active):hover::before {
    z-index: 20;
    content: '';
    display: block;
    width: 15px;
    height: 15px;
    border-radius: 0 0 15px 0;
    background-color: #e7e7e7;
    right: 0;
    top: -15px;
    position: absolute;
}

li:not(.router-active):hover::after {
    z-index: 20;
    content: '';
    display: block;
    width: 15px;
    height: 15px;
    border-radius: 0 15px 0 0;
    background-color: #e7e7e7;
    right: 0;
    bottom: -15px;
    position: absolute;
}

.has-classification {
    margin-top: 10px;
}

.classification {
    display: block;
    height: 20px;
    line-height: 20px;
    padding-left: 20px;
    font-size: 12px;
    color: #999;
}

.has-classification-2 {
    &:not(:first-of-type) {
        .classification {
            position: relative;
            display: block;

            &::before {
                content: '';
                position: absolute;
                left: 10px;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
                height: 1px;
                background-image: linear-gradient(270deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.10) 50%, rgba(0,0,0,0) 100%);
            }
        }
    }
}
</style>
